const FormTitle = ({ title }) => {
    return (
        <div className="section-title">
            <h2 className="title">{title}</h2>
        </div>
    )
}

export default FormTitle